export const customComponentSupportLibraryVersion = '1.9.0'
